import React from "react";

import { DEAL_TYPE_KEYS, ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { useScroll } from "@FillInTableContainer/components/FillInTable/hooks/useScroll";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";
import { useGetNumberOfTable } from "@FillInTableContainer/shared/hooks/useGetNumberOfTable";
import { isRequiredGroupTable } from "@FillInTableContainer/shared/utils/getOptionsFromData";
import { getGroupTableTitle } from "@FillInTableContainer/shared/utils/getTextFromData";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealLaScKeyCommentListCreatorTable from "./components/DealLaScKeyCommentListCreatorTable/DealLaScKeyCommentListCreatorTable";
import { DEAL_LA_SC_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT } from "./constants/dealLaScKeyCommentGroupTableLayout";
import * as S from "./DealLaScKeyCommentGroupTable.style";

const listLayout = DEAL_LA_SC_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT;
const groupTableIndex = 5;

const ARTICLE_SECTION = ENTRY_DATA_SECTION_KEYS.dealsLaSc;

const DealLaScKeyCommentGroupTable = () => {
  const { isMergeAndAcquisition, currentDealTypeList } =
    useCurrentDealTypeValue();

  const { register } = useScroll();
  const { tableCount } = useGetNumberOfTable();
  const articleSection = ARTICLE_SECTION;

  const { checkDisableEdit } = useCanEditGroupTable();
  // NOTE: DealLaScDealTermsGroupTable(V2)와 동일하게 M&A·순수 Venture Formation(VF && !LA) 만 제외한다.
  // VF+LA 는 LA 우선으로 V2 가 담당하므로 Key Comment 도 여기서 렌더한다.
  if (isMergeAndAcquisition) return null;
  if (
    currentDealTypeList.includes(DEAL_TYPE_KEYS.ventureFormation) &&
    !currentDealTypeList.includes(DEAL_TYPE_KEYS.licenseAgreement)
  ) {
    return null;
  }

  // NOTE: 모든 V2 카테고리는 M&A/VF 와 동일한 "Key Comment List"(복수) 구조를 쓴다.
  const { groupTableKey } = listLayout;

  return (
    <S.GroupTableWrapper
      isDisableEdit={checkDisableEdit(groupTableKey)}
      {...register("Key Comment (New)")}
    >
      <TableCreatorGroupTableTitle
        title={getGroupTableTitle(articleSection, groupTableKey)}
        isRequired={isRequiredGroupTable(articleSection, groupTableKey)}
      />
      <S.TableCreatorTableListWrapper
        isDisableEdit={checkDisableEdit(groupTableKey)}
      >
        {newArrayToCountValue(tableCount(groupTableKey)).map(
          (_, tableIndex) => (
            <DealLaScKeyCommentListCreatorTable
              key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
              tableKey={listLayout.tableList[0].tableKey}
              groupShellList={listLayout.tableList[0].groupShellList}
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              tableIndex={tableIndex}
            />
          ),
        )}
      </S.TableCreatorTableListWrapper>
    </S.GroupTableWrapper>
  );
};

export default DealLaScKeyCommentGroupTable;
